import { render, staticRenderFns } from "./m-edit-select-organization-owned-endpoint.vue?vue&type=template&id=7aee1fda&scoped=true&"
import script from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"
export * from "./m-edit-select-organization-owned-endpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aee1fda",
  null
  
)

export default component.exports